// src/components/Navbar.jsx
import React, { useEffect, useRef } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle';
import { motion } from 'framer-motion';
import ResponsiveImage from './ResponsiveImage';

function Navbar() {
  const navRef = useRef();
  const togglerRef = useRef();

  useEffect(() => {
    const navLinks = document.querySelectorAll('#navbarResponsive .nav-link');
    navLinks.forEach((link) =>
      link.addEventListener('click', () => {
        const toggler = togglerRef.current;
        if (toggler && window.getComputedStyle(toggler).display !== 'none') {
          toggler.click();
        }
      })
    );

    const overlay = document.createElement('div');
    overlay.className = 'nav-overlay';
    document.body.appendChild(overlay);

    const navbar = document.getElementById('navbarResponsive');

    const handleShow = () => {
      document.body.classList.add('nav-open');
      overlay.style.display = 'block';
    };

    const handleHide = () => {
      document.body.classList.remove('nav-open');
      overlay.style.display = 'none';
    };

    navbar.addEventListener('shown.bs.collapse', handleShow);
    navbar.addEventListener('hidden.bs.collapse', handleHide);

    overlay.addEventListener('click', () => {
      const toggler = togglerRef.current;
      if (toggler) toggler.click();
    });

    return () => {
      navbar.removeEventListener('shown.bs.collapse', handleShow);
      navbar.removeEventListener('hidden.bs.collapse', handleHide);
      overlay.remove();
    };
  }, []);

  return (
    <motion.nav
      className="navbar navbar-expand-lg"
      ref={navRef}
      id="mainNav"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut', delay: 0.3 }}
    >
      <div className="container">
        <div className='custom-wrapper'>
          <Link className="navbar-brand" to="/">
            <ResponsiveImage
              src="akrion-logo.webp"
              sizes="(max-width: 768px) 150px, 200px"
              alt="Poliklinika Akrion"
              style={{height: '50px'}}
              loading="eager"
            />
          </Link>
          <button
            ref={togglerRef}
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>

        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ms-auto py-lg-0">
            <li className="nav-item">
              <a className="nav-link f-p1" href="/#about">O nama</a>
            </li>
            <li className="nav-item">
              <a className="nav-link f-p1" href="/#portfolio">Usluge</a>
            </li>
            <li className="nav-item">
              <a className="nav-link f-p1" href="/#team">Naš tim</a>
            </li>
            <li className="nav-item">
              <a className="nav-link f-p1" href="/#gallery">Galerija</a>
            </li>
            <li className="nav-item">
              <Link to="/cjenik" className='nav-link f-p1'>Cjenik</Link>
            </li>
            <li className="nav-item">
              <Link to="/blog" className='nav-link f-p1'>Blog</Link>
            </li>
            <li className="nav-item">
              <a className="nav-link f-p1" href="/#contact">Pošalji upit</a>
            </li>
          </ul>
        </div>
      </div>
    </motion.nav>
  );
}

export default Navbar;